import React from "react";
import { Button, Hint, ImageUpload } from "best-common-react-3";
import { useTranslation } from "react-i18next";

type ProfilePictureUploadProps = {
  onUpload: (file: File) => void;
};

const ProfilePictureUpload: React.FC<ProfilePictureUploadProps> = ({ onUpload }) => {
  const { t } = useTranslation(["profile", "translation", "documents"]);
  const [file, setFile] = React.useState<File>();

  return (
    <div>
      <div className="d-flex justify-content-center bcr-mb-2">
        <Hint variant="bodyMedium">{t("profile:supportedPhotoTypes")}</Hint>
      </div>
      <ImageUpload
        id="profile-picture-upload"
        file={file}
        setFile={(file?: File) => {
          setFile(file);
        }}
        height={350}
        width={350}
        fileTypes={["image/png", "image/jpeg", "image/jpg"]}
        fileAttachmentProps={{
          placeholder: t("documents:dropFilesHere"),
          browseButtonText: t("translation:browse"),
        }}
      />
      <div className="d-flex justify-content-center bcr-mt-2 bcr-mb-2">
        <Hint variant="bodyMedium">{t("profile:photoHelpText")}</Hint>
      </div>
      <Button className="w-100" variant="primary" onClick={() => onUpload(file)} disabled={!file}>
        {t("translation:upload")}
      </Button>
    </div>
  );
};

export default ProfilePictureUpload;
